import React from 'react';
import useCrmRoutes from '../../../hooks/useCrmRoutes';
import List from './List';
import Details from './Details';
import Put from './Put';
import InternalRoutes from '../../../components/_organisms/InternalRoutes';

const Roles: React.FC = () => {
  const { isCrmInternalRoute, actualRoute } = useCrmRoutes();

  const routes = [
    {
      component: Put,
      name: 'Roles',
      path: `/crm/${actualRoute}/create`,
    },
    {
      component: Details,
      exact: true,
      name: 'Roles',
      path: `/crm/${actualRoute}/:id`,
    },
    {
      component: Put,
      name: 'Roles',
      path: `/crm/${actualRoute}/:id/edit`,
    },
  ];

  if (isCrmInternalRoute) {
    return <InternalRoutes routes={routes} />;
  }

  return <List />;
};

export default Roles;
